module.exports = __webpack_public_path__ + "static/media/about-us-1056.d357e285.jpg";